import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { withTranslation } from 'react-i18next'
import classNames from 'classnames'
import { translateFormFieldLabel } from '../../../../../../helpers/collaborativeIndexations'

class Name extends Component {

    static propTypes = {
        t: PropTypes.func.isRequired,
        updateFieldValue: PropTypes.func.isRequired,
        fields: PropTypes.object.isRequired,
        isInvalidField: PropTypes.func.isRequired,
        resetInvalidField: PropTypes.func.isRequired,
        hasFocus: PropTypes.bool,
    }

    constructor(props)
    {
        super(props)

        this.mainField = React.createRef()
    }

    componentDidMount()
    {
        if(this.props.hasFocus === true)
        {
            this.mainField.current.focus()
        }
    }

    updateFieldValueFromEvent = (field) => (event) => {
        this.props.resetInvalidField(field)
        this.props.updateFieldValue(field, event.target.value)
    }

    render()
    {
        const { t, fields, isInvalidField } = this.props

        return (
            <React.Fragment>
                <div className={'form-group'}>
                    <label>{translateFormFieldLabel(t, 'lastname')}</label>
                    <input
                        ref={this.mainField}
                        defaultValue={fields.lastname}
                        onChange={ this.updateFieldValueFromEvent('lastname') }
                        type={ 'text' }
                        className={classNames({'error': isInvalidField('lastname')})}
                    />
                </div>
                <div className={'form-group'}>
                    <label>{translateFormFieldLabel(t, 'firstname')}</label>
                    <input defaultValue={fields.firstname}  onChange={this.updateFieldValueFromEvent('firstname')} type={'text'}/>
                </div>
            </React.Fragment>
        )
    }
}

export default withTranslation()(Name)
